import React, { useCallback, useMemo, useState } from 'react';

import { toAbsoluteUrl } from '../../../utils/toAbsoluteUrl';

import {
  SectionTitle,
  HelpText,
  QrWrapper,
  QrImage,
  ActionButton,
  SecondaryButton,
  CopyLinkButton,
  CopiedToast,
  CardSection,
  CountdownPill,
} from '../styles';

type Props = {
  kycLinkUrl?: string;
  kycQrPayload?: string;
  onRefresh: () => void;
};

const KycView: React.FC<Props> = ({ kycLinkUrl, kycQrPayload, onRefresh }) => {
  const absoluteKycLinkUrl = useMemo(
    () => (kycLinkUrl ? toAbsoluteUrl(kycLinkUrl) : ''),
    [kycLinkUrl]
  );
  const hasQr = Boolean(kycQrPayload);
  const hasLink = Boolean(absoluteKycLinkUrl);
  const [copied, setCopied] = useState(false);

  const copyLink = useCallback(() => {
    if (!absoluteKycLinkUrl) return;

    navigator.clipboard
      .writeText(absoluteKycLinkUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch(() => {});
  }, [absoluteKycLinkUrl]);

  return (
    <>
      <SectionTitle>Validação de Biometria</SectionTitle>

      <CountdownPill>
        <span>Aguardando validação</span>
      </CountdownPill>

      {hasQr && (
        <>
          <HelpText>
            Escaneie o QR Code abaixo com a câmera do seu celular.
          </HelpText>
          <QrWrapper>
            <QrImage src={kycQrPayload} alt="QR Code para biometria na Pagarme" />
          </QrWrapper>
        </>
      )}

      {!hasQr && !hasLink && (
        <HelpText>
          Nenhum link de biometria disponível no momento. Clique em
          &ldquo;Atualizar&rdquo; para tentar novamente.
        </HelpText>
      )}

      {hasLink && (
        <CardSection>
          <a
            href={absoluteKycLinkUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <ActionButton type="button">Fazer biometria</ActionButton>
          </a>

          <CopyLinkButton type="button" onClick={copyLink} disabled={!hasLink}>
            {copied ? (
              <CopiedToast>Link copiado!</CopiedToast>
            ) : (
              <>Copiar link</>
            )}
          </CopyLinkButton>
        </CardSection>
      )}

      <CardSection>
        <SecondaryButton type="button" onClick={onRefresh}>
          Atualizar status
        </SecondaryButton>
      </CardSection>
    </>
  );
};

export default KycView;
